import { Box } from '@mui/material';
import { LoaderSize, SmallLoader } from 'framework/ui/mui-builder';
import { statusConfig } from '../../constants';
import useAvailabilityUserStatus from '../hooks/useAvailabilityUserStatus';

type CardUserStatusFieldProps = Readonly<{
  employeeId?: string | null;
}>;

const STATUS_SX = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
  flexShrink: 0,
  px: 0.75,
  py: 0.25,
  borderRadius: 2,
  border: '1px solid',
  borderColor: 'divider',
  fontSize: 11,
  lineHeight: 1,
  backgroundColor: 'var(--mui-palette-background-paper)',
  color: 'text.secondary',
} as const;

const ICON_SX = {
  width: 12,
  height: 12,
} as const;

const CardUserStatusField = ({ employeeId }: CardUserStatusFieldProps) => {
  const { loading, status } = useAvailabilityUserStatus(employeeId);

  if (loading && !status) {
    return (
      <span className="flex items-center">
        <SmallLoader size={LoaderSize.ExtraSmall} />
      </span>
    );
  }

  if (!status) {
    return null;
  }

  return (
    <Box component="span" sx={STATUS_SX}>
      <Box component="img" src={statusConfig[status].icon} alt="" aria-hidden="true" sx={ICON_SX} />
      {statusConfig[status].label}
    </Box>
  );
};

export default CardUserStatusField;
